import { gql } from '@apollo/client';

export const A3_BADGE = gql`
  fragment a3Badge on A3Badge {
    id
    name
    description
    orderNumber
  }
`;

export const ASSIGN_BADGE_TO_USER = gql`
  mutation AssignBadgeToUser($badgeId: UUID, $userId: Int) {
    assignBadgeToUser(badgeId: $badgeId, userId: $userId) {
      id {
        userId
        badgeId
      }
    }
  }
`;

export const A3_BADGE_REQUIREMENT = gql`
  mutation A3BadgeRequest {
    a3BadgeRequest
  }
`;

export const A3_BADGE_LIST = gql`
  query A3BadgeList {
    a3BadgeList {
      ...a3Badge
    }
  }
  ${A3_BADGE}
`;
